import { GInput, GRadioGroup, GSelect, InputLabeledContainer, TextInput } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS, STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import GHref from 'tennders-market/common/components/element/GHref'
import { withPaymentTermForm } from 'tennders-market/common/hocs/withPaymentTermForm'
import { withSharedNegotiation } from 'tennders-market/common/hocs/withSharedNegotiation'
import useSession from 'tennders-auth/hooks/useSession'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import useTranslator from 'tennders-common/form/hooks/useTranslator'

const FirstOffer = ({
  transaction,
  options,
  paymentTermForm,
  submitting,
  sendBid,
  paymentTerms,
  disabled,
  paymentTermProps,
  standardSelected,
  editPaymentTerms
}) => {
  const { isCarrierUser } = useSession()
  const { t } = useTranslation()
  const selectItems = { priceTypes: useTranslator(options?.priceTypes, 'variables') }

  if (!transaction.marketPrice && transaction?.matchedLoad.isMarketPlaced && transaction?.status?.label === STATUS_WAITING_FOR_OFFER) {
    return (
      <>
        <h4 className="bold">First Offer</h4>
        <div className="mb-10 pb-10 border-b">
          <div className="bg-color-white p-16">
            <div className="d-flex row">
              <GInput
                {...paymentTermProps}
                type="currency"
                name="marketPrice"
                eClass="mr-8 mb-10"
                label="Bid Price"
                style={{ maxWidth: 120 }}
                maxLength={INPUT_CHARACTER_LIMITS.PRICE}
                className="form-input small w-auto"
              />
            </div>
            <div className="mt-10">
              <GHref
                disabled={!paymentTermForm?.marketPrice}
                submitting={submitting}
                onClick={() => sendBid({ marketPaymentTerms: paymentTermForm })}
                className="btn standard-btn small"
              >
                {t('offer:' + (isCarrierUser ? 'quote' : 'send_bid'))}
              </GHref>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    !transaction.marketPrice && transaction?.status?.label === STATUS_WAITING_FOR_OFFER
      ? (
        <>
          <h4 className="bold">Enter Payment Terms</h4>
          <div className="mb-10 pb-10 border-b">
            <div className="bg-color-white p-16">
              <div className="d-flex row">
                <GInput
                  {...paymentTermProps}
                  type="currency"
                  name="marketPrice"
                  eClass="mr-8 mb-10"
                  label="Price"
                  style={{ maxWidth: 120 }}
                  maxLength={INPUT_CHARACTER_LIMITS.PRICE}
                  className="form-input small w-auto"
                />
                {isCarrierUser
                  ? (
                    <InputLabeledContainer
                      {...paymentTermProps}
                      label={t('tableRow:priceType')}
                      className="mr-8"
                      name="priceType"
                      renderInput={(rest) => (
                        <TextInput
                          {...rest}
                          disabled
                          value={selectItems?.priceTypes?.find((p) => p.value === paymentTermProps?.form?.priceType)?.label}
                        />
                      )}
                    />
                  )
                  : (
                    <GSelect
                      {...paymentTermProps}
                      eClass="mr-8 mb-10"
                      className="form-input small w-auto"
                      items={options?.priceTypes}
                      name="priceType"
                      label="Price Type"
                      style={{ maxWidth: 120 }}
                    />
                  )}
                {editPaymentTerms && (
                  <>
                    <GSelect
                      {...paymentTermProps}
                      eClass="mr-8 mb-10"
                      className="form-input small w-auto"
                      items={paymentTerms}
                      name="type"
                      label="Payment Type"
                      style={{ maxWidth: 120 }}
                    />
                    <GSelect
                      {...paymentTermProps}
                      eClass="mr-8 mb-10"
                      className="form-input small w-auto"
                      items={options?.paymentTermDateTypes}
                      disabled={standardSelected}
                      name="dType"
                      label="Payment From"
                      style={{ maxWidth: 120 }}
                    />
                    <GInput
                      {...paymentTermProps}
                      type="number"
                      name="days"
                      eClass="mr-8 mb-10"
                      label="Days"
                      style={{ maxWidth: 60 }}
                      className="form-input small w-auto"
                    />
                    <GRadioGroup
                      label="CMR"
                      name="cmrType"
                      items={options?.cmrTypes}
                      {...paymentTermProps}
                    />
                  </>
                )}
              </div>
              <div className="mt-10">
                <GHref
                  disabled={disabled}
                  submitting={submitting}
                  onClick={() => sendBid({ marketPaymentTerms: paymentTermForm })}
                  className="btn standard-btn small mt-10"
                >
                  {t('offer:' + (isCarrierUser ? 'quote' : 'send_bid'))}
                </GHref>
              </div>
            </div>
          </div>
        </>
      )
      : null
  )
}

export default withSharedNegotiation(withPaymentTermForm(FirstOffer))
